export const RETRY_SMS_COUNTDOWN_SECONDS = 60

export const MIN_SMS_RETRIALS = 2

// time to wait until we notify timeout to our backend after application analysis started
export const APPLICATION_TIMEOUT_SECONDS = 300 // 5 min
